import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { map, Observable } from 'rxjs';

import { AgricolaDashboardCard } from '../../../interfaces/agricola.interface';
import { AgricolaService } from '../../../services/agricola.service';
import { MeService } from '../../../services/me.service';

@Component({
  selector: 'app-agricola-dashboard',
  templateUrl: './agricola-dashboard.component.html',
  styleUrls: ['./agricola-dashboard.component.css'],
  standalone: false
})
export class AgricolaDashboardComponent implements OnInit {

  userName$: Observable<string>;

  cards: AgricolaDashboardCard[] = [];

  constructor(
    private router: Router,
    private agricolaService: AgricolaService,
    meService: MeService
  ) {
    this.userName$ = meService.currentUser$.pipe(
      map(user => user?.name || user?.email || 'Usuario')
    );
  }

  ngOnInit(): void {
    this.agricolaService.getDashboardCards().subscribe((cards) => {
      this.cards = cards;
    });
  }

  onCardClick(card: AgricolaDashboardCard): void {
    if (card.id === 1) {
      this.agricolaService.tmkMode = false;
      this.router.navigate(['/agricola/client-search']);
    } else if (card.id === 2) {
      this.router.navigate(['/agricola/reportes']);
    } else if (card.id === 3) {
      this.router.navigate(['/agricola/policy-queries']);
    } else if (card.id === 4) {
      // Aperturas Telemarketing: misma captura, emisión diferida.
      this.agricolaService.tmkMode = true;
      this.router.navigate(['/agricola/client-search']);
    }
  }
}
